import {
  GetApiTimesheetsByUuidRowsError,
  GetApiTimesheetsByUuidRowsResponse,
  GetApiTimesheetsByUuidRowsVariables,
  getTimesheetRowsQueryData,
  TimesheetRow,
  useGetTimesheetRows as useGetApiTimesheetRows,
} from '@sit/client-shared';
import { QueryKey, UseQueryOptions, useQueryClient } from '@tanstack/react-query';
import { generateRowAutofill } from '@web/redux/TimesheetRows/helpers';
import isEqual from 'lodash/isEqual';
import { useEffect } from 'react';

export function useGetTimesheetRowsWithAutofills(
  variables: Omit<GetApiTimesheetsByUuidRowsVariables, 'pathParams'> & { pathParams: { id: string | undefined } },
  options?:
    | Omit<
        UseQueryOptions<GetApiTimesheetsByUuidRowsResponse, GetApiTimesheetsByUuidRowsError, GetApiTimesheetsByUuidRowsResponse, QueryKey>,
        'queryKey' | 'queryFn' | 'initialData'
      >
    | undefined,
) {
  const queryClient = useQueryClient();

  const result = useGetApiTimesheetRows(variables, options);

  // FIXME: This is a workaround to the omission of `onSuccess`'s removal in `@tanstack/react-query` v5.
  // However, it's super useful for this use-case where we want to trigger an action after the data is fetched.
  // This behaviour will be removed once we migrate to server-side autofills.
  useEffect(() => {
    if (!result.data || !variables.pathParams.id) return;
    const existingTimesheetRows = getTimesheetRowsQueryData(queryClient, variables.pathParams.id);
    const rowsToUpdateAutofills: TimesheetRow[] = [];
    for (const newRow of result.data) {
      const existingRow = existingTimesheetRows?.find((row) => row.id === newRow.id);

      if (!existingRow || !isEqual(newRow, existingRow)) {
        // If the row is new or updated, perform GenerateRowAutofill
        rowsToUpdateAutofills.push(newRow);
      }
    }

    rowsToUpdateAutofills.map((row) => generateRowAutofill({ row }));
  }, [result.data, queryClient, variables.pathParams.id]);

  return result;
}
